import PrintableSummaryScreen from './PrintableSummary'

export default PrintableSummaryScreen
